import { useQuery } from "@tanstack/react-query";
import { getInvoicesByJobEvent } from "../actions/getInvoicesByJobEvent";
import type { IInvoice } from "../../create/interfaces/invoice.interfaces";

export const useGetInvoicesByJobEvent = (jobEventUid: string | undefined) => {
  return useQuery<IInvoice[]>({
    queryKey: ["invoices", "by-job-event", jobEventUid],
    queryFn: () => getInvoicesByJobEvent(jobEventUid!),
    enabled: !!jobEventUid,
  });
};
